





















































































































































































































































import moment from 'moment';

import { mapActions, mapGetters } from 'vuex';
import { ErrorManager } from '@/models/error';

import Functions from '@/mixins/functions';
import mixins from '@/utils/mixins';
import auth from '@/mixins/auth';
import { Employee, IEmployee, IEmployeeTimeOffBookingBalance } from '@/models';
import EmployeePicker from '@/components/employee/EmployeePicker.vue';
import ErrorAlert from '@/components/common/ErrorAlert.vue';
import EmployeeTimeOffEntitlementYearPicker from '@/components/employee-time-off/EmployeeTimeOffEntitlementYearPicker.vue';
import TimeOffExportBalancesFilterDialog from '@/components/time-off-calendar/TimeOffExportBalancesFilterDialog.vue';
import ALPage from '@/components/core/Page/ALPage.vue';
import { DataTableHeader } from 'vuetify';
import { isDateInPast } from '@/utils/dateHelpers';
const baseMixins = mixins(Functions, auth);
const DEFAULT_TABLE_ROW_HEIGHT = 48;

interface Options extends InstanceType<typeof baseMixins> {
  $refs: {
    files: HTMLInputElement;
    timeOffExportBalancesFilterDialog: InstanceType<
      typeof TimeOffExportBalancesFilterDialog
    >;
  };
}

export default baseMixins
  .extend<Options>({ functional: false })
  .extend({
    components: {
      EmployeePicker,
      ErrorAlert,
      EmployeeTimeOffEntitlementYearPicker,
      TimeOffExportBalancesFilterDialog,
      ALPage
    },
    data() {
      return {
        loading: false,
        formDialog: false,
        deleteDialog: false,
        employeeloading: false,

        sortBy: 'id',
        sortDesc: true,

        errorMessage: '',
        detailErrorMessage: '',
        employeeErrorMessage: '',

        userEmployee: null as null | IEmployee,

        page: 1,
        timeOffBalances: [] as IEmployeeTimeOffBookingBalance[],
        selectedYear: new Date().getFullYear()
      };
    },

    computed: {
      ...mapGetters({
        employeeTimeOffBalance: 'employeeTimeOff/getEmployeeTimeOffBalances',
        supervisorEmployees: 'employee/getEmployees',
        getEmployeeById: 'employee/getEmployeeById'
      }),

      errorOccurred(): boolean {
        return this.errorMessage.length > 0;
      },

      supervisorEmployeesList(): IEmployee[] {
        return [...this.supervisorEmployees, this.userEmployee];
      },

      balanceTableHeaders(): DataTableHeader[] {
        return [
          {
            text: 'Time Off Type',
            sortable: false,
            value: 'employee_entitlement.timeoff',
            width: 180
          },
          {
            text: 'Effective Date',
            sortable: false,
            value: 'employee_entitlement.effective_date',
            width: 180
          },
          {
            text: 'Yearly Entitlement',
            sortable: false,
            align: 'center',
            value: 'employee_entitlement.yearly_entitlement',
            width: 180
          },
          {
            text: 'Previous Year Carryover',
            sortable: false,
            align: 'center',
            value: 'employee_entitlement.carryover_balance',
            width: 200
          },
          {
            text: 'Total Entitlement',
            sortable: false,
            align: 'center',
            value: 'total_entitlement',
            width: 200
          },
          {
            text: 'Carryover Used',
            sortable: false,
            align: 'center',
            value: 'carryover_used',
            width: 150
          },
          {
            text: 'Total Amount Used',
            sortable: false,
            align: 'center',
            value: 'amount_used',
            width: 150
          },
          {
            text: 'Balance Carried Forward',
            sortable: false,
            align: 'center',
            value: 'balance_carried_forward',
            width: 150
          },
          {
            text: 'Remaining Balance',
            sortable: false,
            align: 'center',
            value: 'remaining_balance',
            width: 180
          },
          {
            text: `${this.selectedYear + 1} Accrual Amount`,
            sortable: false,
            align: 'center',
            value: 'accrual_amount',
            width: 200
          },
          {
            text: 'Time Off Unit',
            sortable: false,
            value: 'employee_entitlement.timeoff_unit.display_unit',
            width: 150
          },
          { text: '', value: 'data-table-expand' }
        ];
      },

      entitlementAmountHeaders(): DataTableHeader[] {
        return [
          {
            text: 'Effective Date',
            sortable: false,
            value: 'effective_date',
            class: 'background grey--text text--darken-1',
            cellClass: 'background grey--text text--darken-1',
            width: 315
          },
          {
            text: 'Expiry Date',
            sortable: false,
            value: 'expiry_date',
            class: 'background grey--text text--darken-1',
            cellClass: 'background grey--text text--darken-1',
            width: 400
          },
          {
            text: 'Amount',
            value: 'value',
            align: 'center',
            sortable: false,
            class: 'background grey--text text--darken-1',
            cellClass: 'background grey--text text--darken-1',
            width: 150
          },
          {
            text: '',
            value: 'active',
            align: 'center',
            class: 'background grey--text text--darken-1',
            sortable: false,
            cellClass: 'background grey--text text--darken-1'
          }
        ];
      }
    },

    async mounted() {
      this.loading = true;
      this.employeeloading = true;

      await this.loadingCurrentUser();

      this.userEmployee = await this.tryGetOrFetchEmployee(
        this.currentUser.employee
      );

      this.searchEmployeeTimeOffInfo(this.userEmployee, this.selectedYear);

      if (!this.isUserHRPersonnel && this.userEmployee) {
        this.fetchEmployees({
          supervisor: this.userEmployee.id!
          // TODO: look into if this needs to be paginated or even called
        })
          .catch(error => {
            this.employeeErrorMessage = ErrorManager.extractApiError(error);
          })
          .finally(() => {
            this.employeeloading = false;
          });
      }
    },

    methods: {
      moment,

      ...mapActions({
        fetchEmployeeTimeOffBalance:
          'employeeTimeOff/fetchEmployeeTimeOffBalance',
        fetchEmployees: 'employee/fetchEmployees',
        fetchEmployee: 'employee/fetchEmployee'
      }),

      openFilterDialog() {
        this.$refs.timeOffExportBalancesFilterDialog.open();
      },

      clearAllErrors(): void {
        this.errorMessage = '';
        this.detailErrorMessage = '';
        this.employeeErrorMessage = '';
      },

      getColor(item: IEmployeeTimeOffBookingBalance) {
        let color = 'green';

        if (this.isExpired(item) || item.remaining_balance! < 0) {
          color = 'red';
        } else if (item.remaining_balance! == 0) {
          color = 'orange';
        }

        return color;
      },

      isExpired(item: IEmployeeTimeOffBookingBalance): boolean {
        return moment(item.employee_entitlement?.expiry_date).isBefore(
          moment().utc(true)
        );
      },

      isCarryOverBalanceExpired(item: IEmployeeTimeOffBookingBalance): boolean {
        return (
          item.employee_entitlement!.carryover_balance! > 0 &&
          item.employee_entitlement!.amounts!.length! == 0
        );
      },

      getCarryOverBalanceColor(item: IEmployeeTimeOffBookingBalance) {
        let color = 'orange';

        if (this.isCarryOverBalanceExpired(item)) {
          color = 'red';
        } else if (item.employee_entitlement!.carryover_balance! > 0) {
          color = 'green';
        }

        return color;
      },

      isDateInPast,

      async tryGetOrFetchEmployee(employeeId: number): Promise<Employee> {
        if (!this.getEmployeeById(employeeId)) {
          await this.fetchEmployee(employeeId)
            .catch(error => {
              this.errorMessage = ErrorManager.extractApiError(error);
            })
            .finally(() => {
              this.loading = false;
            });
        }
        return this.getEmployeeById(employeeId);
      },

      searchEmployeeTimeOffInfo(employee: IEmployee | null, year: number) {
        if (!employee) {
          this.timeOffBalances = [];
          return;
        }

        this.clearAllErrors();

        return this.fetchEmployeeTimeOffBalance({
          employee: employee.id,
          year: year
        })
          .then(() => {
            this.timeOffBalances = this.employeeTimeOffBalance;
          })
          .catch(error => {
            this.errorMessage = ErrorManager.extractApiError(error);
            if (error.response.data.detail) {
              this.detailErrorMessage = error.response.data.detail;
            }
          })
          .finally(() => {
            this.loading = false;
          });
      },

      /** wait for currentuser to load first before resolving */
      loadingCurrentUser(): Promise<void> {
        if (this.currentUser.id) {
          return Promise.resolve();
        }

        return new Promise(resolve => {
          const watcher = this.$watch('currentUser.id', () => {
            resolve();
            watcher();
          });
        });
      },

      calcEmployeeEntitlementAmountsHeight(amounts: number): number {
        return amounts * DEFAULT_TABLE_ROW_HEIGHT + DEFAULT_TABLE_ROW_HEIGHT;
      }
    }
  });
